<template>
  <div class="content-8__controlbar">
    <template v-if="status">
      <!-- Object.keys(data).length === 0 -->
      <template v-if="isloading">
        <HK6PininLoading />
      </template>
      <template v-else>
        <div class="content-8__controlbar__item">
          <div class="c8-select justify-between">
            <div class="c8-select__content flex-1">
              <a class="button-primary c8-select__content__item" :class="{'active': 'all' === activePick}" @click.prevent="pick('all')">
                <span class="button-primary__text">全部</span>
              </a>
              <a v-for="(value, index) in data" :key="`${index}`" class="button-primary c8-select__content__item" :class="{'active': index === activePick}" @click.prevent="pick(index)">
                <span class="button-primary__text">{{ index }}</span>
              </a>
            </div>
            <div class="c8-select__search">
              <input v-model="search" type="text" placeholder="请输入您要查找的图纸名称">
              <a class="button-outline c8-select__content__item" @click.prevent="send">
                <span class="button-outline__text">搜寻</span>
              </a>
            </div>
          </div>
        </div>
        <div v-if="key.length > 0" class="content-8__controlbar__item">
          <div c8-select justify-between>
            搜寻 <span class="button-outline__text Keyword">"{{ key.join('') }}"</span> 的结果,
            共找到 <span class="button-outline__text Keyword">"{{ serchResult }}"</span> 笔相关图库
          </div>
        </div>
        <template v-if="Object.keys(data).length === 0">
          <NoData />
        </template>
        <template v-else>
          <div class="content-8__content border-bottom" style="min-height: 300px;">
            <template v-for="(value, index) in data">

              <div v-if="activePick === 'all'" :key="`${index}`" class="c8-select">
                <h1 class="c8-select__title">
                  <span class="c8-select__title__text font-30 red">{{ index }}</span>
                </h1>
                <div class="c8-select__content">
                  <div v-for="(item, itemIndex) in value" :key="`${itemIndex}`" class="button-outline c8-select__content__item" @click="gotoTuku(item.id)" v-html="markSelect(item.name)"></div>
                </div>
              </div>

              <div v-if="activePick === index" :key="`${index}`" class="c8-select">
                <h1 class="c8-select__title">
                  <span class="c8-select__title__text font-30 red">{{ index }}</span>
                </h1>
                <div class="c8-select__content">
                  <div v-for="(item, itemIndex) in value" :key="`${itemIndex}`" class="button-outline c8-select__content__item" @click="gotoTuku(item.id)" v-html="markSelect(item.name)"></div>
                </div>
              </div>
            </template>
          </div>
        </template>
      </template>

    </template>
    <template v-else>
      <ImagesList
        :tuku-category="activeTuku"
        type="hk6"
        :parent-year="currentYear"
        :previous-tab-index="previousTabIndex"
        :current-tab-index="currentTabIndex"
        :direct-enter-image-item="directEnterImageItem"
        @backHK6="backHK6"
        @resetHK6="resetHK6"
      />
    </template>
  </div>
</template>

<script>
import HK6PininLoading from '@/components/desktop/common/skeleton/HK6PininLoading'
import NoData from '@/components/desktop/common/NoData'
import ImagesList from '@/components/desktop/pages/images/ImagesList'
import { getThisAndLastYear } from '@/utils/commonLib'
import { getTukusList } from '@/api/desktop/images'

export default {
  name: 'Hk6Pinyin',
  components: {
    ImagesList,
    NoData,
    HK6PininLoading
  },
  props: {
    currentTabIndex: {
      type: Number,
      default: 0
    },
    previousTabIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      data: {},
      status: true,
      activePick: 'all',
      search: '',
      key: [],
      activeTuku: [],
      isloading: false,
      currentYear: '',
      directEnterImageItem: false
    }
  },
  computed: {
    serchResult() {
      let result = 0
      for (const a in this.data) {
        result += this.data[a].length
      }
      return result
    }
  },
  async mounted() {
    await this.getTukusList({ cpCode: 'hk6' })
    const { categoryID, year } = this.$route.query

    const categoryIdToCheck = this.checkCategoryID(categoryID)
    if (!categoryIdToCheck) {
      this.status = true
      this.resetHK6()
    } else {
      this.status = false
      this.currentYear = this.checkYear(year)
      this.selectTuku(parseInt(categoryIdToCheck))
    }
  },
  methods: {
    async getTukusList(code, query) {
      this.isloading = true
      const [data, error] = await getTukusList(code, query)
      this.isloading = false
      if (error) {
        console.error(error)
        return
      }
      this.data = data
    },
    pick(value) {
      this.activePick = value
    },
    send() {
      this.activePick = 'all'
      this.getTukusList({ cpCode: 'hk6', name: this.search })
      this.key = this.search.split('')
    },
    markSelect(name) {
      const wordArray = name.split('').map(word => {
        if (this.key.includes(word)) {
          return `<span class='button-outline__text Keyword'>${word}</span>`
        } else {
          return word
        }
      })
      return wordArray.join('')
    },
    selectTuku(value) {
      this.activeTuku[0] = value
      this.status = false
    },
    gotoTuku(value) {
      this.selectTuku(value)
      this.directEnterImageItem = true
    },
    backHK6(data) {
      this.status = data
    },
    resetHK6() {
      this.currentYear = (getThisAndLastYear()[0]).toString()
      this.$router.push({ query: {}})
      this.search = ''
      this.send()
    },
    findMatchCategoryIdItem(id) { // 找出符合 categoryID 的資料
      const matchedCategory = Object.values(this.data).find(categories => {
        return categories.find(category => category.id === parseInt(id))
      })
      return matchedCategory ? matchedCategory.find(category => category.id === parseInt(id)) : null
    },
    checkCategoryID(categoryID) { // 檢查是否有符合 categoryID 的 id
      return categoryID && this.findMatchCategoryIdItem(categoryID) ? parseInt(categoryID) : ''
    },
    checkYear(year) {
      return getThisAndLastYear().includes(parseInt(year)) ? year : (getThisAndLastYear()[0]).toString()
    }
  }
}
</script>

<style lang="scss" scope>
// .hk6 {
//   padding-bottom: 50px;
// }
// .select {
//   display: flex;
//   justify-content: space-between;
//   padding: 30px 30px;
//   margin-bottom: 10px;
//   border-style: solid;
//   border-color: #E4E7ED;
//   border-width: 1px;
//   &-pinin {
//     cursor: pointer;
//     &-item {
//       margin-right: 15px;
//       line-height: 40px;
//       padding-bottom: 4px;
//       font-size: 20px;
//       &:hover {
//         background-color: #E4E7ED;
//       }
//       &--active {
//         border-bottom-style: solid;
//         border-bottom-color: #409EFF;
//         border-width: 2px;
//         color: #409EFF;
//       }
//     }
//   }
//   &-input {
//     min-width: 250px;
//   }
// }
// .searchresult {
//   background-color: #d3cfcf;
//   display: flex;
//   padding: 12px;
//   &-title {
//     cursor: default;
//     color: #EA5C39;
//     height: 100%;
//     margin: 0 16px;
//   }
//   &-list {
//     cursor: pointer;
//     display: flex;
//     flex-wrap: wrap;
//     &-item {
//       margin: 8px;
//       line-height: 16px;
//       font-size: 16px;
//       &:hover {
//         background-color: #e8e8e8;
//       }
//     }
//   }
//   &:nth-child(odd) {
//     background-color: #c1bfbf;
//   }
// }
.Keyword {
  // background-color: #FFFF00;
  color: red;
}
.content-8__content{
  .c8-select{
    padding: 16px 16px 8px;
    box-sizing: border-box;
    border-bottom: solid 1px #EBEBEB;
    &:nth-child(odd){
      background: #F8F8F8;
    }
  }
}
.justify-between{
justify-content: space-between;
}
.c8-select__search{
white-space: nowrap ;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s ease;
}
.fade-enter, .fade-leave-to
/* .component-fade-leave-active for below version 2.1.8 */ {
  opacity: 0;
}
</style>

